<template>
  <div class="pa-2">
    <div class="text--secondary mb-4">Selecione o tipo do imóvel / local</div>

    <v-select
      v-model="internalValue"
      :items="types"
      item-text="text"
      item-value="value"
      label="Tipologia"
      outlined
      dense
      :color="insurer.color"
      clearable
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: "RiskLocationTypologyStep",

  props: {
    value: {
      type: String,
      default: null,
    },
    insurer: Object,
  },

  data() {
    return {
      internalValue: null,

      types: [
        { text: "Moradia", value: "house" },
        { text: "Apartamento", value: "apartment" },
        { text: "Garagem", value: "garage" },
        { text: "Escritório", value: "office" },
        { text: "Espaço comercial", value: "commercial_room" },
        { text: "Armazém", value: "warehouse" },
        { text: "Terreno", value: "land" },
        { text: "Prédio", value: "building" },
      ],
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.internalValue = val || null;
      },
    },
  },

  methods: {
    handleChange(val) {
      this.$emit("input", val);

      // dispara complete só quando realmente escolheu algo
      if (val) this.$emit("complete");
    },
  },
};
</script>
